import React, { useState } from "react";
import { Row, Col, Button, Form , Modal, Image } from "react-bootstrap";
import validator from "validator";
import InputGroup from "react-bootstrap/InputGroup";

import { CountrySelector } from '../../utils/react-country-selector/components/selector';
import { COUNTRIES } from '../../utils/react-country-selector/constants/countries';
import { SelectMenuOption } from '../../utils/react-country-selector/types/index';
import 'react-phone-number-input/style.css'
import Input from 'react-phone-number-input/input'
import { CountryCode } from "libphonenumber-js/types";
import libphonenumber from 'google-libphonenumber';
import styles from "./IndividualProposal.module.css";

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

function ProposalSubmissionModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={styles.modalMain}
        >
            <Modal.Body>
                <div className={styles.modalTitle}>
                    <div className={styles.modalTitleText}>
                        Your Proposal is Submitted
                    </div>
                </div>
                <div className={styles.modalFooterText}>
                    Thank you for your contribution
                </div>
            </Modal.Body>
        </Modal>
    );
}


const initialState = ({
    email: "",
    verificationCode: "",
    country:"BE",
    phone:"",
    terms: false
})



function IndividualForm() {
    const myRef = React.createRef<HTMLDivElement>();
    const [isCountryOpen, setisCountryOpen] = useState(false);
    const [form, setForm] = useState(initialState);
    const [modalShow, setModalShow] = React.useState(false);

    const [errors, setErrors ] = useState<any>({})

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
        if(!errors[field]) {
            setErrors({
                ...errors,
                [field]: null
            })
        }
    }

    const findFormErrors = () => {
        const { email, verificationCode, country, phone, terms } = form;
        const newErrors: any = {};

        if(!email || email === '') newErrors.email = 'Email is required';
        else if(validator.isEmail(email) == false) newErrors.email = 'Email is not valid';

        if(!verificationCode || verificationCode === '') newErrors.verificationCode = 'Please Enter 4 digit code';
        else if(validator.isVerificationCode(verificationCode) == false) newErrors.verificationCode = 'Verification code is not valid';

        if (!phone || phone === '') newErrors.phone = 'You must enter a phone number'
        else if (phoneUtil.isValidNumberForRegion(phoneUtil.parseAndKeepRawInput(phone), country) == false) newErrors.phone = 'The phone number should be valid to the country region'

        if (!terms) newErrors.terms = 'You must agree to the vote terms'

        return newErrors;
    }

    const handleSubmit = e => {
        e.preventDefault()
        // get our new errors
        const newErrors = findFormErrors()
        // Conditional logic:
        if (Object.keys(newErrors).length > 0) {
            // We got errors!
            setErrors(newErrors)
        } else {
            // No errors! Put any logic here for the form submission!
            setModalShow(true)
        }
    }

    return (
        <Row className={styles.ContentContainer}>
            <Form noValidate onSubmit={handleSubmit}>
                <h2 style={{textAlign:'center',fontFamily:'montserrat', fontWeight:'bold',marginRight:'4rem'}}>Verify Your Email</h2>
                <h6 style={{textAlign:'center',fontFamily:'montserrat', fontStyle:'italic'}}>Voter Verification takes an average of two minutes or less to complete</h6>
                <Row className="mb-3" style={{textAlign: 'left'}}>
                    <Form.Group as={Col} md="6" controlId="valicationCountry">
                    <Form.Label className={styles.inputLabel}>Email</Form.Label>
                        <Form.Control
                            size="lg"
                            required
                            type="text"
                            placeholder="Enter your email address"
                            className={styles.inputStyle}
                            value={form.email}
                            onChange={(e) => setField('email', e.target.value)}
                            isInvalid={errors.email}
                        />
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationCustom02">
                    <Button className={styles.voteVerificationBtn}>
                    <div className={styles.voteVerificationText}>
                      Send Verification Code
                    </div>
                    </Button>
                    </Form.Group>
                </Row>
                <Row className="mb-3" style={{textAlign: 'left'}}>
                    <Form.Group as={Col} md="3" controlId="validationCustomUsername">
                    <Form.Label className={styles.inputLabel}>Enter verification code</Form.Label>
                    <Form.Control
                            size="lg"
                            required
                            type="text"
                            placeholder="23456"
                            className={styles.inputStyle}
                            value={form.verificationCode}
                            onChange={(e) => setField('verificationCode', e.target.value)}
                            isInvalid={errors.verificationCode}
                        /> 
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <h5 style={{fontFamily:'montserrat', textAlign: 'center',backgroundColor: 'transparent',fontWeight: 'bold', padding: '30px'}}>Select Region</h5>
                <Row className="mb-3" style={{textAlign: 'left'}}>
                <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Country</Form.Label>
                        <CountrySelector
                            id={'countries'}
                            ref={myRef}
                            open={isCountryOpen}
                            onToggle={() => setisCountryOpen(!isCountryOpen)}
                            onChange={country =>setField('country', country)}
                            // value={form.country}
                            selectedValue={COUNTRIES.find(option => option.value === form.country) as SelectMenuOption}
                        />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Phone</Form.Label>
                        <Form.Control
                            as={Input}
                            name="phone"
                            placeholder="Enter phone number"
                            className={styles.phoneInput}
                            country={`${form.country}`}
                            onChange={phone => setField('phone', phone)}
                            value={form.phone}
                            isInvalid={!!errors.phone}

                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.phone}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Form.Group className="mb-3" style={{textAlign: 'left'}}>
                    <Form.Check
                        required
                        label="Agree to terms and conditions"
                        feedback={errors.terms}
                        feedbackType="invalid"
                        onChange={() => setField('terms', !form.terms)}
                        isInvalid={errors.terms}
                    />
                </Form.Group>
                <Button type="submit" className={styles.voteButton}>
                    <div className={styles.voteButtonText}>Vote</div>
                </Button>
                <ProposalSubmissionModal show={modalShow} onHide={() => setModalShow(false)} />
            </Form>
        </Row>
    );
}

export default IndividualForm;